module.exports = {
  translations: {
    // metamask
    'metamask.pleaseInstallFirst': 'Please install MetaMask first!',
    'metamask.youNeedSignMessage': 'You need to sign the message to be able to use system!',
    'metamask.youHaveBeenBlocked': `System has detected that you have withdrawn money from smartcontract. 
    Therefore, for security reason, your account has been locked. Please contact us if you have any questions.`,
    'metamask.onlySupportNetwork': `Tomorrowsprice only supports {{network}} network in Ethereum blockchain. Please check your network.`,
  }
}